import React, { forwardRef } from 'react';
import cx from 'classnames';
import type { DropdownMenuContentProps as RadixDropdownMenuContentProps } from '@radix-ui/react-dropdown-menu';
import { Content } from '@radix-ui/react-dropdown-menu';

import type { BaseThemeVariants } from 'Storybook/config/types';
import { Variant } from 'Types/variant';
import { applyCypressData } from 'Utilities/helpers';

import styles from './DropdownMenuContent.module.scss';

export type DropdownMenuContentProps = RadixDropdownMenuContentProps &
	React.RefAttributes<HTMLDivElement> & {
		cypressId?: string;
		side?: 'center' | 'right' | 'left';
		size?: 'small' | 'regular' | 'large';
		variant?: BaseThemeVariants;
	};

const DropdownMenuContent = forwardRef<HTMLDivElement, DropdownMenuContentProps>(
	(
		{ children, className, cypressId, side = 'right', size = 'regular', variant = Variant.PRIMARY, ...props },
		forwardedRef,
	) => (
		<Content
			ref={forwardedRef}
			className={cx(styles.content, styles[side], styles[size], styles[variant], className)}
			data-testid="dropdown-menu-content"
			{...applyCypressData(cypressId)}
			{...props}
		>
			{children}
		</Content>
	),
);

export default DropdownMenuContent;
